import { gql } from "@apollo/client";

export default gql`
  query explainAiMessageStep($data: ExplainAiMessageStepInput!){
    explainAiMessageStep(data: $data){
        success
        data
        code
        message
    }
}
`
